import React, { useEffect, useRef, useState } from 'react';

const BigStatement = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="min-h-screen flex items-center justify-center bg-white text-black py-20 px-6 md:px-12">

      <div className="container mx-auto max-w-6xl text-center">
        <h2
          className="md:text-8xl lg:text-9xl !font-bold !text-6xl !text-center mb-6"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
            transition: 'opacity 1.2s ease-out, transform 1.2s ease-out'
          }}>Artificial Intelligence, put to work


        </h2>
        <p
          className="md:text-2xl !font-light !text-2xl text-gray-600"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 1s ease-out 0.5s, transform 1s ease-out 0.5s'
          }}>

          From research-grade methods to real-world systems.
        </p>
      </div>
    </section>);

};

export default BigStatement;